import { POST } from "api";
import { Breadcrumbs, Field, LabelBar, ModalPanel, Table } from "components";
import InputPanel from "components/input-panel/input-panel";
import dayjs from "dayjs";
import React, { Component } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import swal from "@sweetalert/with-react";
import { getToken_permission_page } from "../../../../../static/function";

export default class GenarateMatchCar extends Component {
     constructor(props) {
          super(props);
          this.state = {
               series_id: this.props.match.params.series,
               model_id: this.props.match.params.model,
               color_id: this.props.match.params.color,
               show_car: false,
               car_order: {},
               car_send: {
                    car_match_date: "",
               },
               showModalCancel: false,
               height: window.innerHeight,
               width: window.innerWidth,
          };
     }
     componentDidMount = () => {
          this.getCarOrder();
          window.addEventListener("resize", this.updateDimensions);
     };
     getCarOrder = async () => {
          let { series_id, model_id, color_id, car_send } = this.state;
          // let date = new Date();
          try {
               let order = await POST("/car/this_to_match", { series_id: series_id, model_id: model_id, color_id: color_id });

               // car_send.car_match_date = dayjs(new Date()).format("YYYY-MM-DD");
               car_send.car_match_date = dayjs(new Date());
               this.setState({ car_order: { ...order }, car_send });
          } catch (err) {
               console.log(err);
          }
     };

     /* ------------------------- onClick ----------------------------- */
     onClickMatchCar = async () => {
          let { show_car, car_send } = this.state;
          car_send.car_match_date = dayjs(car_send.car_match_date).format("YYYY-MM-DD");
          this.setState({ showModalCancel: !this.state.showModalCancel });
          try {
               if (car_send.car_id && car_send.order_id) {
                    let result = await POST("/car/set_match", car_send);
                    if (result === "match success") {
                         swal({
                              icon: "success",
                              text: "จับคู่รถเรียบร้อย",
                              content: <span className="info">รายการจับคู่รถนี้จะสมบูรณ์เมื่อทาง VDQI ยืนยันการจับคู่</span>,
                              buttons: {
                                   submit: "เสร็จสิ้น",
                              },
                         }).then((value) => {
                              // window.location.assign(`/admin/match/list/${car_send.car_id}/${car_send.order_id}`);
                              window.location.reload();
                         });
                    }
               } else {
                    swal({
                         icon: "warning",
                         text: "กรุณาเลือกรถเพื่อจับคู่",
                         buttons: {
                              danger: "เสร็จสิ้น",
                         },
                    });
               }
          } catch (err) {
               swal({
                    icon: "warning",
                    text: err,
                    // content: <span className="info">{err}</span>,
                    buttons: {
                         danger: "เสร็จสิ้น",
                    },
               });
          }
     };

     /* ------------------------ onChange ----------------------------- */
     handleSelectDate = (date, dateString, name) => {
          let { car_send } = this.state;
          car_send[name] = date;
          this.setState({ car_send, dateSend: date });
     };
     handleChangeText = (e) => {
          let { car_send } = this.state;
          car_send[e.target.name] = e.target.value;
          this.setState({ car_send });
     };
     onChangeCheckboxAdd = (e, id, name) => {
          let { car_send } = this.state;
          if (e.target.checked) {
               car_send[name] = id;
          }
          this.setState({ car_send });
     };
     /* ------------------------ Formatter ---------------------------- */
     checkBoxFormatter = (row, isSelect, rowIndex, e) => {
          // console.log(row);
          // console.log(isSelect);
          // console.log(rowIndex);
          // console.log(e);
          let { car_send } = this.state;

          if (row && row.car_id) {
               car_send["car_id"] = row.car_id;
          } else if (row && row.order_id) {
               car_send["order_id"] = row.order_id;
          }
          // console.log(`car_send`, car_send);
          // <Form.Check type="radio" name={formatExtraData} value={rowIndex} onChange={(e) => this.onChangeCheckboxAdd(e, row.order_id, formatExtraData)} />
          this.setState({ car_send });
     };

     dateFormatter = (cell, row, rowIndex, formatExtraData) => {
          return dayjs(cell).format("DD/MM/") + (dayjs(cell).year() + 543);
     };
     detailFormatter = (cell, row, rowIndex, formatExtraData) => {
          switch (formatExtraData) {
               case "operator":
                    return <a>{cell}</a>;
          }
     };
     detailFormatterBooking(cell, row, rowIndex, formatExtraData) {
          return <a onClick={() => window.location.assign(`/admin/order/car/detail${row.order_id}`)}>{cell}</a>;
     }
     parseFloatFormatter = (cell, row) => {
          let new_cell = parseFloat(cell ? cell : 0).toLocaleString(undefined, {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
          });
          if (row.field === "summary-total") {
               return <span className="text">{new_cell}</span>;
          } else {
               return new_cell;
          }
     };

     differenceDateFormatter = (cell, row, rowIndex, formatExtraData) => {
          // console.log("row", row);
          // let date = new Date();
          // let current_date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          let current_date = dayjs(new Date()).format("YYYY-MM-DD");
          return Math.abs(dayjs(row.created_at).diff(current_date, "day")) + 1;
     };

     noteFormatter = (cell, row) => {
          if (cell) {
               let acc = JSON.parse(cell);
               // let acc_filter = acc.filter((el, i) => acc.map((ele) => ele.items_name).indexOf(el.items_name) === i);
               let acc_filter = acc
               return (
                    <div>
                         {/* <strong style={{ color: "#000" }}>รายการอุปกรณ์ติดตั้ง</strong> */}
                         {/* <br></br> */}
                         {acc_filter?.map((el, i) => (
                              <>
                                   {i + 1}.{` ${el.items_name}`}
                                   <br></br>
                              </>
                         ))}
                         {/* - อุปกรณ์ 1<br></br>- อุปกรณ์ 2<br></br>- อุปกรณ์ 3<br></br>- อุปกรณ์ 4<br></br> */}
                    </div>
               );
          } else {
               return <span>-</span>;
          }
     };

     onClickCancelModal = () => {
          this.setState({ showModalCancel: !this.state.showModalCancel });
     };

     updateDimensions = () => {
          this.setState({
               height: window.innerHeight,
               width: window.innerWidth,
          });
     };

     render() {
          let { car_order, car_send, width, height } = this.state;
          const selectRow = {
               mode: "radio",
               clickToSelect: true,
               onSelect: this.checkBoxFormatter,
               style: { background: "#ccffdd" },
          };

          const table_car = {
               column: [
                    {
                         dataField: "series_name",
                         text: "Serie",
                         formatter: (e) => (e ? e : "-"),
                         headerClasses: "header-custom __btn-s",
                    },
                    {
                         dataField: "model_name",
                         text: "Model",
                         formatter: (e) => (e ? e : "-"),
                         headerClasses: "header-custom __btn-ss",
                    },
                    {
                         dataField: "color_name",
                         text: "สี",
                         formatter: (e) => (e ? e : "-"),
                         headerClasses: "header-custom __5em",
                    },
                    {
                         dataField: "car_tank",
                         text: "เลขตัวถัง",
                         formatter: (e) => (e ? e : "-"),
                         headerClasses: "header-custom __btn-m",
                    },
                    {
                         dataField: "car_engine",
                         text: "เลขเครื่องยนต์",
                         formatter: (e) => (e ? e : "-"),
                         headerClasses: "header-custom __8em",
                    },
                    {
                         dataField: "age_product",
                         text: "อายุสินค้า (วัน)",
                         formatter: this.differenceDateFormatter,
                         headerClasses: "header-custom __btn-ss",
                    },
                    {
                         dataField: "car_fun",
                         text: "ราคาทุน",
                         formatter: this.parseFloatFormatter,
                         headerClasses: "header-custom __btn-ss",
                    },
                    {
                         dataField: "car_price",
                         text: "ราคาขาย",
                         formatter: this.parseFloatFormatter,
                         headerClasses: "header-custom __btn-ss",
                    },
                    // {
                    //      dataField: "car_vat",
                    //      text: "ราคาขาย (รวม Vat)",
                    //      headerClasses: "header-custom __btn",
                    //      formatter: this.parseFloatFormatter,
                    // },
                    {
                         dataField: "acc_installed",
                         text: "รายการอุปกรณ์ที่ติดตั้งแล้ว",
                         headerClasses: "header-custom __btn-match-car",
                         formatter: this.noteFormatter,
                    },
                    {
                         dataField: "car_note",
                         text: "หมายเหตุ",
                         headerClasses: "header-custom __right __btn-m",
                         formatter: (e) => (e ? e : "-"),
                    },
               ],
               data: car_order.car ? car_order.car : [],
               keyField: "car_id",
          };

          const table_preemption_car = {
               column: [
                    // {
                    //      dataField: "select",
                    //      text: "เลือก",
                    //      formatter: this.checkBoxFormatter,
                    //      headerClasses: "header-custom __no",
                    //      formatExtraData: "order_id",
                    // },
                    {
                         dataField: "orp_date",
                         text: "วันเวลาที่ชำระค่าจอง",
                         formatter: this.dateFormatter,
                         headerClasses: "header-custom __10em",
                    },
                    {
                         dataField: "getcar_date",
                         text: "วันรับรถ",
                         formatter: this.dateFormatter,
                         headerClasses: "header-custom __9p",
                    },
                    {
                         dataField: "order_code_id",
                         text: "เลขที่ใบจอง",
                         formatter: this.detailFormatterBooking,
                         formatExtraData: "operator",
                         headerClasses: "header-custom __10p",
                    },
                    {
                         dataField: "userinfo_name",
                         text: "ชื่อลูกค้า",
                         headerClasses: "header-custom btn-ml",
                         formatter: (e) => (e ? e : "-"),
                    },
                    {
                         dataField: "saler_name_string",
                         text: "ชื่อพนักงานขาย",
                         headerClasses: "header-custom  __btn",
                         formatter: (e) => (e ? e : "-"),
                    },
                    {
                         dataField: "discount_price",
                         text: "ส่วนลด (บาท)",
                         formatter: this.parseFloatFormatter,
                    },
                    {
                         dataField: "note",
                         text: "หมายเหตุ",
                         headerClasses: "header-custom __right",
                         formatter: (e) => (e ? e : "-"),
                    },
               ],
               data: car_order.order ? car_order.order : [],
               keyField: "order_id",
          };
          let token = getToken_permission_page();
          let per = token ? JSON.parse(token.permission_page) : [];
          let addBtn = per.filter((el) => el.path === "/admin/match/car")[0].add || false;
          return (
               <div className="panel">
                    <Breadcrumbs
                         title={[
                              {
                                   title: `จับคู่รถให้ลูกค้า`,
                                   onClick: () => window.location.assign("/admin/match/car"),
                              },
                              { title: `จัดรถให้แก่ลูกค้า` },
                         ]}
                         active={1}
                         button={""}
                    />
                    <div className="content __input-panel">
                         <div className="input-field">
                              <div className="-body">
                                   <div className="content">
                                        {/* <LabelBar type={"title"} title={"รายละเอียดของ Invoice"} />
                                        <div className="-padding">
                                             <Row>
                                                  <LabelBar
                                                       type={"textheader"}
                                                       title={{
                                                            name: "เลขที่ใบ Invoice : ",
                                                            detail: "20200000000",
                                                       }}
                                                       md={6}
                                                  />
                                             </Row>
                                             <Row>
                                                  <LabelBar
                                                       type={"textheader"}
                                                       title={{
                                                            name: "Invoice Date : ",
                                                            detail: "วว/ดด/ปป",
                                                       }}
                                                       md={6}
                                                  />
                                             </Row>
                                        </div> */}
                                        <LabelBar type={"title"} title={"รายละเอียดเกี่ยวกับรถ"} />
                                        <div className="-padding">
                                             <Row>
                                                  <LabelBar
                                                       type={"textheader"}
                                                       title={{
                                                            name: "Series : ",
                                                            detail: car_order?.series_name,
                                                       }}
                                                       md={6}
                                                  />
                                             </Row>
                                             <Row>
                                                  <LabelBar
                                                       type={"textheader"}
                                                       title={{
                                                            name: "Model : ",
                                                            detail: car_order?.model_name,
                                                       }}
                                                       md={6}
                                                  />
                                             </Row>
                                             <Row>
                                                  <LabelBar
                                                       type={"textheader"}
                                                       title={{
                                                            name: "สี : ",
                                                            detail: car_order?.color_name,
                                                       }}
                                                       md={6}
                                                  />
                                             </Row>
                                        </div>
                                   </div>
                                   <div className="content" style={{ paddingBottom: "0" }}>
                                        <LabelBar type={"title"} title={"รถในสต๊อกที่พร้อมจับคู่"} />
                                   </div>

                                   <div className="content checkcenter" id="table-content" style={{ paddingTop: "0" }}>
                                        <div className="-padding detail-match-car">
                                             <Table
                                                  type={"summary-custom-padding"}
                                                  selectRow={selectRow}
                                                  column={table_car.column}
                                                  data={table_car.data}
                                                  keyField={table_car.keyField}
                                             />
                                        </div>
                                   </div>
                                   <div className="content" style={{ paddingBottom: "0" }}>
                                        <LabelBar type={"title"} title={"เลือกใบจองที่สามารถจับคู่กับรถได้"} />
                                   </div>
                                   <div className="content checkcenter" id="table-content" style={{ paddingTop: "0" }}>
                                        <div className="-padding">
                                             <Table
                                                  noscroll={width > 1348 ? true : false}
                                                  type={"summary-custom-padding"}
                                                  selectRow={selectRow}
                                                  column={table_preemption_car.column}
                                                  data={table_preemption_car.data}
                                                  keyField={table_preemption_car.keyField}
                                             />
                                        </div>
                                   </div>
                                   <div className="content">
                                        <div className="-padding">
                                             <InputPanel
                                                  type={"textarea"}
                                                  title={"หมายเหตุ"}
                                                  name="car_match_note"
                                                  rows={3}
                                                  handleChange={(e) => this.handleChangeText(e)}
                                             />
                                        </div>

                                        <Field
                                             handleSelectDate={this.handleSelectDate}
                                             type={"date"}
                                             title={"กำหนดวันจับคู่"}
                                             placeholder={"เลือกวันที่"}
                                             md={3}
                                             formatDate={"DD/MM/YYYY"}
                                             value={this.state.dateSend || dayjs(new Date())}
                                             require={false}
                                             name="car_match_date"
                                        />
                                   </div>
                              </div>
                         </div>
                         {addBtn && (
                              <div className="button-group __submit row">
                                   <Col xs={6}>
                                        <Button id={"btn_proceed"} type="submit" onClick={this.onClickCancelModal}>
                                             จับคู่รถ
                                        </Button>
                                   </Col>
                                   <Col xs={6}>
                                        <Button id={"btn_reset"} variant="danger">
                                             Reset
                                        </Button>
                                   </Col>
                              </div>
                         )}
                         <ModalPanel
                              show={this.state.showModalCancel}
                              title={"ต้องการจับคู่รถหรือไม่"}
                              type={"default"}
                              onHide={() => this.onClickCancelModal()}
                              button={[
                                   { onClick: () => this.onClickMatchCar(), name: "ตกลง", variant: "primary" },
                                   { onClick: () => this.onClickCancelModal(), name: "ยกเลิก", variant: "outline-primary" },
                              ]}
                         />
                    </div>
               </div>
          );
     }
}
